import Main from './main';
import GeneralUtility from './utility/general-utility';
import UserSettings from './utility/user-settings';

document.addEventListener('DOMContentLoaded', () => {
  // Setup global event listeners
  let orientation = GeneralUtility.getDeviceOrientation();
  let previousOrientation: string = '';
  window.addEventListener('resize', () => {
    orientation = GeneralUtility.getDeviceOrientation();
    if (orientation !== previousOrientation) {
      GeneralUtility.deviceOrientationChangeEvent.dispatch(orientation);
    }
    previousOrientation = orientation;
  }, {'capture': false, 'passive': true});

  // Initialize main class
  new Main();
});

window.addEventListener('beforeunload', () => {
  UserSettings.getInstance().refresh();
});
